module.exports = __webpack_public_path__ + "static/media/jewelish.0f14f7ec.jpg";